import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/image/bg-itb.webp'
import _imports_1 from '@/assets/image/logo.webp'


const _hoisted_1 = { class: "min-h-screen flex items-center justify-center p-6 relative overflow-hidden font-sans" }
const _hoisted_2 = { class: "flex-shrink-0 flex items-center justify-between px-6 py-5 gap-3" }
const _hoisted_3 = { class: "flex items-center gap-3" }
const _hoisted_4 = { class: "text-right max-w-[220px]" }
const _hoisted_5 = { class: "text-xs font-semibold text-slate-700 truncate" }
const _hoisted_6 = { class: "text-[11px] text-slate-500 truncate" }
const _hoisted_7 = { class: "relative group flex-shrink-0" }
const _hoisted_8 = {
  key: 0,
  class: "mx-6 mt-4 px-4 py-3 rounded-xl border border-amber-300 bg-amber-50 text-amber-800 text-[13px]"
}
const _hoisted_9 = {
  key: 1,
  class: "flex flex-col items-center gap-3 py-16 text-slate-400 text-sm"
}
const _hoisted_10 = {
  key: 2,
  class: "flex items-center gap-2.5 mx-6 my-5 px-4 py-3 bg-red-50 border border-red-200 rounded-xl text-red-600 text-[13px]"
}
const _hoisted_11 = {
  key: 3,
  class: "overflow-y-auto px-6 pt-5 pb-6 flex flex-col gap-6"
}
const _hoisted_12 = { class: "flex flex-col gap-3" }
const _hoisted_13 = { class: "grid grid-cols-4 gap-3" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = {
  key: 0,
  class: "absolute top-2 right-2 text-[9px] font-bold bg-amber-100 text-amber-800 rounded-full px-1.5 py-0.5"
}
const _hoisted_16 = { class: "text-[12.5px] font-semibold text-slate-700 text-center leading-tight" }
const _hoisted_17 = { class: "flex flex-col gap-3" }
const _hoisted_18 = {
  key: 0,
  class: "text-center py-6 text-slate-400 text-[13.5px] italic bg-slate-50 rounded-xl border-[1.5px] border-dashed border-slate-200"
}
const _hoisted_19 = {
  key: 1,
  class: "grid grid-cols-2 gap-3"
}
const _hoisted_20 = ["onClick"]
const _hoisted_21 = {
  key: 0,
  class: "flex items-center gap-2.5 px-4 py-3 bg-red-50 border border-red-200 rounded-xl text-red-600 text-[13px]"
}
const _hoisted_22 = { class: "flex justify-end pt-1" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = {
  key: 0,
  class: "selector-btn-spinner inline-block w-[15px] h-[15px] rounded-full border-2 border-white/40 border-t-white"
}
const _hoisted_25 = { class: "w-14 h-14 bg-red-50 rounded-full flex items-center justify-center mx-auto mb-4 text-red-600" }
const _hoisted_26 = { class: "flex gap-2.5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconLogout = _resolveComponent("IconLogout")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[19] || (_cache[19] = _createElementVNode("div", { class: "fixed inset-0 z-0 overflow-hidden" }, [
      _createElementVNode("img", {
        src: _imports_0,
        class: "absolute inset-0 w-full h-full object-cover object-center scale-105"
      }),
      _createElementVNode("div", { class: "absolute inset-0 bg-[rgba(208,226,255,0.82)]" })
    ], -1)),
    _createElementVNode("div", {
      class: _normalizeClass(["selector-card relative z-10 bg-white rounded-2xl w-[680px] max-w-full shadow-2xl flex flex-col overflow-visible", { 'selector-card--ready': !_ctx.loading }]),
      style: {"max-height":"calc(100vh - 80px)"}
    }, [
      _createElementVNode("div", _hoisted_2, [
        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "flex items-center gap-3" }, [
          _createElementVNode("img", {
            src: _imports_1,
            alt: "IOM ITB",
            class: "h-11 w-auto flex-shrink-0",
            onerror: "this.style.display='none'"
          }),
          _createElementVNode("div", null, [
            _createElementVNode("p", { class: "text-sm font-bold text-slate-900 mb-0.5" }, "Ikatan Orang Tua Mahasiswa"),
            _createElementVNode("p", { class: "text-xs text-slate-500" }, "Institut Teknologi Bandung")
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.currentUser?.name || _ctx.currentUser?.preferredUsername || '-'), 1),
            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.currentUser?.email || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("button", {
              class: "w-[38px] h-[38px] rounded-[9px] border border-slate-200 bg-slate-50 text-slate-500 flex items-center justify-center cursor-pointer transition-all duration-150 hover:bg-red-50 hover:border-red-300 hover:text-red-600",
              "aria-label": "Logout",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showLogoutConfirm = true))
            }, [
              _createVNode(_component_IconLogout)
            ]),
            _cache[7] || (_cache[7] = _createElementVNode("span", { class: "selector-tooltip pointer-events-none absolute bottom-[calc(100%+8px)] left-1/2 -translate-x-1/2 bg-slate-800 text-white text-[11.5px] font-medium px-2.5 py-1 rounded-md whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-150" }, " Logout ", -1))
          ])
        ])
      ]),
      _cache[16] || (_cache[16] = _createElementVNode("div", { class: "flex-shrink-0 h-px bg-slate-100 mx-6" }, null, -1)),
      (_ctx.accessWarning)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.accessWarning), 1))
        : _createCommentVNode("", true),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [...(_cache[9] || (_cache[9] = [
            _createElementVNode("div", { class: "selector-spinner w-[30px] h-[30px] rounded-full border-[3px] border-slate-200 border-t-blue-800" }, null, -1),
            _createElementVNode("p", null, "Memuat daftar aplikasi...", -1)
          ]))]))
        : (_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _cache[10] || (_cache[10] = _createElementVNode("svg", {
                width: "18",
                height: "18",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round"
              }, [
                _createElementVNode("circle", {
                  cx: "12",
                  cy: "12",
                  r: "10"
                }),
                _createElementVNode("line", {
                  x1: "12",
                  y1: "8",
                  x2: "12",
                  y2: "12"
                }),
                _createElementVNode("line", {
                  x1: "12",
                  y1: "16",
                  x2: "12.01",
                  y2: "16"
                })
              ], -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.error) + " ", 1),
              _createElementVNode("button", {
                class: "ml-auto bg-red-600 text-white border-none rounded-md px-3 py-1 text-xs cursor-pointer",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.loadApps && _ctx.loadApps(...args)))
              }, "Coba lagi")
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _cache[11] || (_cache[11] = _createElementVNode("p", { class: "text-[15px] font-bold text-slate-900" }, "Daftar Aplikasi", -1)),
                _createElementVNode("div", _hoisted_13, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.apps, (app) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: app.id,
                      class: _normalizeClass(["relative flex flex-col items-center justify-center gap-2.5 px-3 pt-5 pb-4 rounded-[14px] border-[1.5px] border-slate-200 bg-slate-50 cursor-pointer transition-all duration-150 min-h-[110px] hover:-translate-y-0.5 hover:border-slate-300 hover:bg-slate-100 hover:shadow-md", { '-translate-y-0.5 shadow-md': _ctx.selectedApp?.id === app.id }]),
                      style: _normalizeStyle(_ctx.selectedApp?.id === app.id
                ? { borderColor: app.color, background: app.colorLight }
                : {}),
                      onClick: ($event: any) => (_ctx.selectApp(app))
                    }, [
                      (app.id === _ctx.originAppId)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_15, " Asal "))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", {
                        class: "w-12 h-12 rounded-xl flex items-center justify-center transition-all duration-150",
                        style: _normalizeStyle({
                  color: _ctx.selectedApp?.id === app.id ? app.color : '#94a3b8',
                  background: _ctx.selectedApp?.id === app.id ? app.colorLight : '#f1f5f9'
                })
                      }, [
                        (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.iconMap[app.iconKey] || _ctx.iconMap.dashboard)))
                      ], 4),
                      _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.getAppDisplayName(app)), 1)
                    ], 14, _hoisted_14))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _cache[12] || (_cache[12] = _createElementVNode("p", { class: "text-[15px] font-bold text-slate-900" }, "Daftar Role", -1)),
                (!_ctx.selectedApp)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, " Pilih aplikasi terlebih dahulu "))
                  : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedApp.roles, (role) => {
                        return (_openBlock(), _createElementBlock("button", {
                          key: role.id,
                          class: _normalizeClass(["flex items-center justify-center px-4 py-[18px] rounded-xl border-[1.5px] border-slate-200 bg-slate-50 cursor-pointer text-sm font-semibold text-slate-600 transition-all duration-150 min-h-[60px] hover:border-slate-300 hover:bg-slate-100 hover:-translate-y-px", { '-translate-y-px shadow-md !font-bold': _ctx.selectedRole?.id === role.id }]),
                          style: _normalizeStyle(_ctx.selectedRole?.id === role.id
                ? { borderColor: _ctx.selectedApp.color, background: _ctx.selectedApp.colorLight, color: _ctx.selectedApp.color }
                : {}),
                          onClick: ($event: any) => (_ctx.selectRole(role))
                        }, _toDisplayString(_ctx.getRoleDisplayName(role)), 15, _hoisted_20))
                      }), 128))
                    ]))
              ]),
              (_ctx.enterError)
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    _cache[13] || (_cache[13] = _createElementVNode("svg", {
                      width: "16",
                      height: "16",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round"
                    }, [
                      _createElementVNode("circle", {
                        cx: "12",
                        cy: "12",
                        r: "10"
                      }),
                      _createElementVNode("line", {
                        x1: "12",
                        y1: "8",
                        x2: "12",
                        y2: "12"
                      }),
                      _createElementVNode("line", {
                        x1: "12",
                        y1: "16",
                        x2: "12.01",
                        y2: "16"
                      })
                    ], -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.enterError), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("button", {
                  class: _normalizeClass(["flex items-center gap-2 px-7 py-[11px] rounded-xl border-none text-white text-sm font-semibold transition-all duration-200 disabled:cursor-not-allowed disabled:opacity-50", _ctx.canEnter && !_ctx.isEntering ? 'hover:opacity-90 hover:-translate-y-px' : '']),
                  style: _normalizeStyle(_ctx.canEnter ? { background: _ctx.selectedApp!.color } : { background: '#cbd5e1' }),
                  disabled: !_ctx.canEnter || _ctx.isEntering,
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleEnter && _ctx.handleEnter(...args)))
                }, [
                  (_ctx.isEntering)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_24))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _cache[14] || (_cache[14] = _createTextVNode(" Masuk ", -1)),
                        _cache[15] || (_cache[15] = _createElementVNode("svg", {
                          width: "15",
                          height: "15",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2.5",
                          "stroke-linecap": "round"
                        }, [
                          _createElementVNode("path", { d: "M5 12h14M12 5l7 7-7 7" })
                        ], -1))
                      ], 64))
                ], 14, _hoisted_23)
              ])
            ]))
    ], 2),
    _createVNode(_Transition, { name: "popup" }, {
      default: _withCtx(() => [
        (_ctx.showLogoutConfirm)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "fixed inset-0 bg-slate-900/50 backdrop-blur-sm flex items-center justify-center z-50",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showLogoutConfirm = false))
            }, [
              _createElementVNode("div", {
                class: "bg-white rounded-[18px] px-7 pt-8 pb-6 w-[360px] max-w-[calc(100vw-32px)] text-center shadow-2xl",
                onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
              }, [
                _createElementVNode("div", _hoisted_25, [
                  _createVNode(_component_IconLogout)
                ]),
                _cache[17] || (_cache[17] = _createElementVNode("h3", { class: "text-[17px] font-bold text-slate-900 mb-2" }, "Konfirmasi Logout", -1)),
                _cache[18] || (_cache[18] = _createElementVNode("p", { class: "text-[13.5px] text-slate-500 mb-6 leading-relaxed" }, " Apakah kamu yakin ingin keluar dari sistem IOM-ITB? ", -1)),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("button", {
                    class: "flex-1 py-2.5 rounded-[9px] border border-slate-200 bg-white text-slate-600 text-[13.5px] font-semibold cursor-pointer transition-all duration-150 hover:bg-slate-50 hover:border-slate-300",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showLogoutConfirm = false))
                  }, " Batal "),
                  _createElementVNode("button", {
                    class: "flex-1 py-2.5 rounded-[9px] border-none bg-red-600 text-white text-[13.5px] font-semibold cursor-pointer transition-opacity duration-150 hover:opacity-90",
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleLogout && _ctx.handleLogout(...args)))
                  }, " Ya, Logout ")
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}